/**
 * Public half of the Worker-held Ed25519 entitlement signing key.
 * Safe to ship in every client. `keyId` supports a future overlap/rotation.
 */
export const ENTITLEMENT_SIGNING_KEYS = {
  v1: {
    crv: 'Ed25519',
    x: 'VzFB2ZbOqq94uIp-Pnx0nx_OvvdGpN0JZsl1vz_7Vtw',
    kty: 'OKP',
  },
} as const satisfies Record<string, JsonWebKey>
